import { UserStatistics } from '@monorepo/user-statistics-common';
import { CountryCodeType, Region } from '../common';
import { ContestAccountRanking } from '../contest-account';

export enum UserProgressStatus {
  Profitable = 'Profitable',
  Funded = 'Funded',
  Verified = 'Verified',
}

export interface LeaderboardFilters {
  country?: CountryCodeType;
  region?: Region;
  fullName?: string;
}

/**
 * Leaderboard pagination and filter options
 * skip and limit are optional for client requests, defaults are applied server-side
 */
export interface PaginateLeaderboardOptions {
  skip: number;
  limit: number;
  disqualified?: boolean;
  attachCurrentUser?: boolean;
  attachPinnedUsers?: boolean;
  filters?: LeaderboardFilters;
}

/**
 * Internal representation of a leaderboard account from database queries
 * This is the raw data structure returned by the contest-account service
 * before enrichment with trading system balance data
 */
export interface LeaderboardAccountResult {
  userId: string;
  ranking: ContestAccountRanking;
  user: {
    fullName: string;
    userName?: string;
    country: string;
    publicId: string;
    profileUrl: string;
  };
  tsAccountId: string;
  userStatistics?: UserStatistics;
}

/**
 * Client-facing leaderboard account with enriched data
 * This is the final format sent to the API consumers
 * after enrichment with balance data and user statistics
 */
export interface LeaderboardAccount {
  publicId: string;
  profilePictureUrl?: string;
  ranking: ContestAccountRanking;
  tsAccountId: string;
  country: string;
  fullName: string;
  userName?: string | null;
  dailyROI: number;
  overallWins: number;
  achievementsCount: number;
  totalPnl: number;
  userProgressStatus: UserProgressStatus | null;
  isPinned?: boolean;
  isCurrentUser?: boolean;
  winRate?: number;
  totalTrades?: number;
  /** Exact prize display name from distributed Prize document (closed contests only) */
  prizeDisplayName?: string;
}

export interface PinUserInput {
  targetPublicId: string;
}
